import styled from "styled-components";

export const OwnerContentStyle = styled.div`
  height: calc(100vh - (72px + 76px));
  background: var(--3, #f2f7ff);
`;
